import { render, staticRenderFns } from "./PolizasFinanzasMovimientos.vue?vue&type=template&id=c3c50370&"
import script from "./PolizasFinanzasMovimientos.vue?vue&type=script&lang=js&"
export * from "./PolizasFinanzasMovimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports